module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "breadcrumb"
  }, [_vm._v("MANAGE BIN")]), _vm._v(" "), _c('el-row', {
    staticClass: "row-bg p-10 mt-10 bg-lightgarg"
  }, [_c('el-col', {
    staticClass: "mr-10",
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    staticClass: "select-bg-s",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "User Type",
      "no-match-text": "No data",
      "no-data-text": "No data"
    },
    on: {
      "change": _vm.getselectlist
    },
    model: {
      value: (_vm.selectUsertype),
      callback: function($$v) {
        _vm.selectUsertype = $$v
      },
      expression: "selectUsertype"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    staticClass: "input-setMaxWidth",
    attrs: {
      "placeholder": "Search anything about users"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.handleIconClick
    },
    slot: "suffix"
  })])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "element-loading-text": "loading...",
      "empty-text": "No data",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.displayName + ' - ' + scope.row.givenName + '  ' + scope.row.familyName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "action",
      "label": "Actions",
      "width": "130",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.restoreUser(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "icon ion-refresh"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.RemoveUser(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-20 mb-50"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.size,
      "current-page": _vm.currentPage,
      "page-count": _vm.totalPages
    },
    on: {
      "current-change": _vm.pageCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e79cd4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/Trash.vue
// module id = 609
// module chunks = 1